module.exports = __webpack_public_path__ + "img/followers.7d29e781.svg";